import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { buildResident } from "./utils";
import useFetch from "./fetch";

function AutoSave () {
  const fetch = useFetch();
  const dispatch = useDispatch();
  const props = useSelector((state) => {
    return {
      resident: state.resident,
      treatmentCenters: state.treatment_centers,
      saving: state.ui.saving,
      updatedAt: state.ui.resident_updated_at,
      organizationName: state.organization.name,
      isStaffApp: state.config.isStaffApp,
    };
  });
  const updateSaving = (saving) => dispatch({ type: "UPDATE_SAVING", payload: { saving }});
  const updateUpdatedAt = (updated_at) => dispatch({ type: "UPDATE_RESIDENT_UPDATED_AT", 
              payload: { resident_updated_at: updated_at }});
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      updateUpdatedAt(props.resident.updated_at);
    } else {
      updateSaving(true);
      const timeout = setTimeout(() => {
        const { organizationName } = props;
        const resident = buildResident(props);
        fetch(`/organizations/${organizationName}/residents/${props.resident.id}.json`, {
          method: "PATCH",
          data: {
            resident
          }
        }).then((data) => {
          updateSaving(false);
          if (props.isStaffApp) alert('Changes successfully saved.')
          updateUpdatedAt(data.resident.updated_at);
        }).fail(()=>{
          if (props.isStaffApp) alert('An erorr occurred and changes were not saved.')
          updateSaving(false)
        })
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, Object.values(props.resident));
  const renderStatus = () => {
    if (props.saving) {
      return (
        <span>Saving...</span>
      );
    }

    return (
      <span>
        <span style={{ 'fontSize': 14 }}>Last updated on </span>
        <span style={{ 'fontSize': 14 }}>{props.updatedAt ? moment(props.updatedAt).format("llll") : null}</span>
      </span>
    );
  }
  return (
    <div>
      {renderStatus()}
    </div>
  );
}

export default AutoSave;
